<template>
    <div class="all">
        <!-- 预警信息列表 -->
        <div class="warp h-auto">
            <div class="warp-body">
                <h2 class="title">信源中心</h2>
                <div class="firle mt10 clearfix">
                    <div class="corm fl clearfix">
                        <span class="element cp" :class="{curr:type === 'follow'}" @click="getList('follow');">重点关注信源设置</span>
                        <!-- <span class="element cp" :class="{curr:type === 'exclude'}" @click="getList('exclude');">排除信源设置</span> -->
                    </div>
                </div>
                <div class="firle mt10 clearfix">
                    <div class="fl clearfix">
						<button class="btn btn-blue" @click="openSource();">新增</button>
						<button class="btn btn-blue" @click="delSource();">全部删除</button>
                    </div>
                    <div class="fr">
                        <span class="tion clearfix">
                            <div class="search-warp clearfix">
                                <button class="search-btn fr"><i class="icons search-icon"></i></button> 
                                <div class="hidden"><input type="text" v-model.trim="keyword" @input="KeyUpEsc" placeholder="输入信源名称搜索" class="input-text"></div>
                            </div>
                        </span>
                    </div>
                </div>
                <table class="table mt20 border" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="10%">
                        <col width="20%">
                        <col width="15%">
                        <col width="15%">
                        <col width="30%">
                        <col width="10%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>序号</th>
                            <th>信源名称</th>
                            <th>媒体类型</th>
                            <th>平台</th>
                            <th>媒体ID/网址</th>
                            <th class="ar">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in list" :key="index">
                            <td>{{index+1}}</td>
                            <td><a class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.source}}</a></td>
                            <td>{{item.originPlatformName}}</td>
                            <td>{{item.platformName}}</td>
                            <td>   
                                <span v-if="item.mediaId!=''">{{item.mediaId}}</span>
                                <a v-else class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.domain}}</a>
                            </td>
                            <td class="ar">
                                <div class="table-all-icons move-bian" v-if="item.id!=undefined">
                                    <a title="删除" @click="delSource(item.id,0)" href="javascript:void(0);" class="icons del-sm-icon"></a>
                                </div>
                                <div v-else>
                                    <span class="switch" :class="peopleLeaderSwitch == 1 ? 'active' : ''" @click="oneButtonSwitch();"><i class="icons switch-icon"></i></span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
            </div>
        </div>
        <!-- 添加信源 -->
        <Dialog :visible.sync="addShow" width="850px" :titleIndex="titleIndex" :modalFoot="false" title="添加信源设置" @sendSelectTitle="getSelecTitle">
            <div v-if="titleIndex === 0" style="height:500px;overflow:auto">
                <div class="clearfix">
                    <div class="search-warp clearfix">
                        <span class="drop-down mores fl">
                            <button class="btn search-dropdown"><span class="texts">{{selectMedias.name}}{{selectMedias.childName!==''?'/':''}}{{selectMedias.childName}}</span><i class="icons"></i></button>
                            <ul class="option">
                                <li v-for="(item,index) in MediaPlatformList" :key="index" @click="selectMediadata(item,1)" v-if="item.name != '全部'">
                                    <div>{{item.name}}</div>
                                    <div class="childMedia">
                                        <div v-for="(child,indexs) in item.children" :key="indexs" @click.stop="selectMediachild(item,child,1)">{{child.name}}</div>
                                    </div>
                                </li>
                            </ul>
                        </span>
                        <button class="search-btn btn-blue fr cp" type="button" @click="searchSource">搜索</button> 
                        <div class="hidden"><input type="text" v-model.trim="keywords" @keyup.enter="searchSource" placeholder="输入信源名称搜索" class="input-text"></div>
                    </div>
                </div>
                <div class="table-father maxH420 minH420">
                    <table v-if="lists != ''" class="table mt20 border" width="100%" border="0" cellpadding="0" cellspacing="0">
                        <colgroup>
                            <col width="25%">
                            <col width="15%">
                            <col width="15%">
                            <col width="30%">
                            <col width="15%">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>信源名称</th>
                                <th class="otherPlatformListHov">
                                    <div class="otherPlatformList" :class="selectMedias.value === 'other'?'otherAction':''">
                                        <div class="plam">媒体类型<i class="icons" v-if="selectMedias.value === 'other'"></i></div>
                                        <div class="PlatformList">
                                            <div v-for="(item,indexs) in otherPlatformList" :key="indexs">
                                                <label class="checkbox-box">
                                                    <label class="checkbox-warp fl" :class="platformList.indexOf(item.value) != -1 ? 'curr' : ''">
                                                        <input class="checkbox" v-model="platformList" name="" type="checkbox" :value="item.value">
                                                        <i class="icons checkbox-icon"></i>
                                                    </label>
                                                    {{item.label}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th>平台</th>
                                <th>网址</th>
                                <th class="ar">操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in lists" :key="index">
                                <td><a class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.source}}</a></td>
                                <td>{{item.originPlatformName}}</td>
                                <td>{{item.platformName}}</td>
                                <td><a class="color-blue" :href="'http://'+item.domain" target="_blank">{{item.domain}}</a></td>
                                <td class="ar">
                                    <div class="table-all-icons move-bian">
                                        <!-- <a title="修改" v-if="tabType != 'wx'" href="javascript:void(0);" @click="editContacts(index);" class="icons edit-icon1"></a> -->
                                        <a class="color-blue" href="javascript:void(0);" v-if="item.isExist === 0" @click="addSource(index);">添加</a>
                                        <a class="color-red" v-if="item.isExist === 1">已添加</a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="no-data" v-if="nodatas"><span class="text">没有数据哦...</span></div>
                </div>
            </div>
            <div style="height:500px" v-if="titleIndex === 1 && !detailFlag">
                <div class="download-warp">
                    <div class="d-flex">
                        <a :href="`${$imgHttp}/yuqing_oem/%E6%A8%A1%E6%9D%BF%E6%96%87%E4%BB%B6.xlsx`">
                            <button class="btn btn-border mr10 cp"><i class="iconfont icon-xiazai01 color-blue mr10"></i>下载模板
                            <div class="grid-info fr">
                            <i class="icons icons-question-circle"></i> 
                            <p class="grid-tip">目前支持网页(一级域名或者二级域名)，微信(微信公众号ID)，微博号(微博网页的ID账号)，抖音(抖音号ID)，快手(快手号ID)批量上传监测；</p>
                        </div></button>
                        </a>
                        <div class="file-warp cur">
                            <input class="file" type="file" ref="file" value="上传文件" @change="updateImg($event);" accept=".xlsx,.xls"/>
                            <button class="btn btn-primary-border btn-border"><i class="iconfont icon-piliangshangchuan color-blue mr10"></i>批量上传</button>
                        </div>
                    </div>
                    <div title="刷新列表状态" class="color-blue cp" @click="getLoadList(1)"><i class="iconfont icon-zhongxinshengcheng"></i></div>
                </div>
                <div class="download-table" v-if="loadList.length > 0">
                    <el-table
                        :data="loadList"
                        style="width:100%;"
                        key="table2"
                        :show-header="false">
                        <!-- <el-table-column type="selection" width="50"></el-table-column> -->
                        <el-table-column type="index"></el-table-column>
                        <el-table-column width="150">
                            <template slot-scope="scope">
                                <div :title="scope.row.name" class="ovhidden">
                                    {{scope.row.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" width="170"></el-table-column>
                        <el-table-column >
                             <template slot-scope="scope">
                                <div :title="scope.row.errorInfo" class="ovhidden">
                                    <span v-if="scope.row.errorInfo.length == 0">— —</span>
                                    <span v-for="(item,index) in scope.row.errorInfo" :key="index" v-else>{{item}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === '1'">
                                    <i class="iconfont mr10 icon-zhengzaishangchuan-01 color-blue"></i>{{scope.row.statusName}}
                                </span>
                                <span v-if="scope.row.status === '2'">
                                    <i class="iconfont mr10 icon-wancheng color-success"></i>{{scope.row.statusName}}
                                </span>
                                <span v-if="scope.row.status === '0'">
                                    <i class="iconfont mr10 icon-denghoushangchuan color-wait"></i>{{scope.row.statusName}}
                                </span>
                                <span v-if="scope.row.status === '-1'">
                                    <i class="iconfont mr10 icon-shibai color-red"></i>上传失败
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column width="98">
                            <template slot-scope="scope">
                                <span :class="scope.row.status === '2'? 'color-blue cp':'color-grey'" @click="lookfor(scope.row)">查看</span>
                                <span :class="scope.row.status === '1' ? 'color-grey':'color-blue cp'" class="ml10" @click="delLoad(scope.row)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <page class="fenye" :currentPage.sync="loadPage" :limit.sync="loadLimit" :totalCount="loadTotal" @turn="getTableData"></page>
                </div>
                <div class="nodata-warp download-warp" v-else>
                    <span>暂无数据</span>
                    <div class="file-warp">
                        <input class="file" type="file" ref="file" value="上传文件" @change="updateImg($event);" accept=".xlsx,.xls"/>
                        <button class="btn save btn-jbblue btn-none"><i class="iconfont icon-piliangshangchuan mr10"></i>点击上传</button>
                    </div>
                </div>
            </div>
            <div style="height:500px" v-if="titleIndex === 1 && detailFlag">
                <button class="btn btn-sussess" @click="detailFlag = false">返回</button>
                <div class="download-table detail-table" v-if="detailList.length > 0">
                    <el-table
                        :data="detailList"
                        style="width:100%;"
                        key="table3"
                        :show-header="false">
                        <el-table-column type="index" width="60"></el-table-column>
                        <el-table-column >
                            <template slot-scope="scope">
                                <div :title="scope.row.source" class="ovhidden">
                                    <span v-if="scope.row.source!=''">{{scope.row.source}}</span>
                                    <span v-else>— —</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platformName"></el-table-column>
                        <el-table-column prop="domain">
                            <template slot-scope="scope">
                                <span class="ovhidden" :title="scope.row.mediaId!=''?scope.row.mediaId:scope.row.domain">{{scope.row.mediaId!=''?scope.row.mediaId:scope.row.domain}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status"></el-table-column>
                        <el-table-column>
                            <template slot-scope="scope">
                                <span class="color-blue cp" v-if="scope.row.status === '成功'" @click="delSource(scope.row.id,1)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog2.vue';
import page from '../../components/page.vue';
export default {
    components:{Dialog,page},
    data() {
        return {
            planId:'',//方案ID
            keyword:'',//关键词
            type:'',
            platformList:[],
            MediaPlatformList:'',//平台列表
            initialList:'',//页面初始展示列表
            list:'',//页面展示列表
            nodata:false,//显示暂无数据
            nodatas:false,//弹框显示暂无数据
            keywords:'',//弹框搜索关键词
            key:'',//搜索的类别
            keys:'',//弹框搜索的类别
            lists:'',//添加信源搜索的列表
            loadList:[],
            detailList:[],
            totalPage:1,
            totalLimit:300,
            totalCount:0,
            pageTotal:0,
            loadPage:1,
            detailPage:1,
            loadTotal:0,
            loadLimit:10,
            detailLimit:1000,
            detailTotal:0,
            addShow:false,
            detailFlag:false,
            titleIndex:0,
            lookId:'',
            docFile:'',
            peopleLeaderSwitch:0,
            selectMedias:{
                name:'网页',
                value:'web',
                childName:'',
                childValue:'',
            },//平台列表
        }
    },
     watch:{
        addShow(){
            if(!this.addShow){
                this.titleIndex = 0;
                this.detailFlag = false;
                this.getList ();
            }
        },
        platformList:{
            handler(){
                let list = this.initialLists;
                if(this.platformList.length === 0){
                    this.lists = list;
                }else{
                    let result;
                    result = list.filter(item => {
                        return this.platformList.indexOf(item.platform) != -1
                    })
                    this.lists = result;
                    if(this.lists == ''){
                        this.nodata = true;
                    }else{
                        this.nodata = false;
                    }
                }   
            }
        },
    },
    mounted() {
        let that = this;
        that.getMediaPlatform();
        that.$api.post('custom/warning/custom-warn-info',{},r =>{
            that.$utils.returnCode(r,function(){
                that.peopleLeaderSwitch = r.data.peopleLeaderSwitch;
            });           
        })
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        oneButtonSwitch(){
            let that = this;
            if(that.peopleLeaderSwitch == 1){
                that.peopleLeaderSwitch = 0;
            }else{
                that.peopleLeaderSwitch = 1;
            }
            that.$api.post('custom/warning/people-leader-switch',{data:{peopleLeaderSwitch:that.peopleLeaderSwitch}},r =>{
                that.$utils.returnCode(r,function(){
                    
                });           
            })
        },
        // 文件上传
        async updateImg (event) {
            await this.getLoadList(1)
            var uploadRes = this.loadList.some((e)=>{
                return e.status == 0 || e.status == 1
            })
            if(!uploadRes){
                let that = this
                let file = event.target.files;
                let files = file[0];
                that.docFile = files;
                var formData = new FormData();
                formData.append('sid', that.planId);
                formData.append('file', that.docFile);
                that.$api.post('custom/info-source/upload',formData,r =>{
                    that.$utils.returnCode(r,function(){
                        event.target.value = '';
                        that.getLoadList(1)
                    });           
            })
            }else{
                event.target.value = '';
                this.$utils.alertText('存在文件未上传完')
            }
        },
        // 查看
        lookfor(item) {
            this.detailList = [];
            if(item.status !== '2') {
                return
            }
            this.detailFlag = true
            this.lookId = item.id
            this.getDetailList()
        },
        // 删除文件
        delLoad(item) {
            let that = this
            if(item.status === '1') {
                return
            }
            let data = {
                sid:that.planId,
                ids:[],
                type:1
            }
            data.ids.push(item.id)
            that.$confirm('是否删除此文件').then(() => {
                that.$api.get('custom/info-source/upload-del',data, r => {
                    that.$utils.returnCode(r,function(){
                        that.getLoadList(1)
                    });
                })
            }).catch(()=>{})
        },
        // 新增信源tab切换
        getSelecTitle(val) {
            this.titleIndex = val
            if(val === 1) {
                this.getLoadList()
            }
        },
        // 获取查看数据列表
        getDetailList() {
            let that = this
            let data = {
                sid:that.planId,
                type:'follow',
                upload_id:that.lookId,
                perpage:that.detailLimit,
                page:that.detailPage
            }
            that.$api.get('custom/info-source/list',data, r => {
                that.$utils.returnCode(r,function(){
                    that.detailTotal = r.data.count
                    let arr = r.data.data.map((ele,index) => {
                        return {...ele,index:index+1}
                    });
                    that.$api.get('monitor/info-source/upload-error',{upload_id:that.lookId}, res => {
                        that.$utils.returnCode(r,function(){
                            that.detailList = arr.concat(res.data)
                        });
                    })
                });
            })
        },
        // 获取信源列表
        getLoadList(type) {
            let that = this
            if(type === 1) {
                that.$parent.loadModal(true,'正在获取数据');
            }
            that.$api.get('custom/info-source/upload-list',{sid:that.planId,page:that.loadPage,perpage:that.loadLimit,type:'follow'}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false
                    let arr = r.data.data.map((ele,index) => {
                        return {...ele,index:index+1}
                    });
                    if(arr.length==0&&that.loadPage != 1){
                        that.loadPage = 1 
                        that.getLoadList(1)
                    }
                    that.loadList = arr
                    that.loadTotal = r.data.total
                });
            })
        },
        getTableData () {
            this.getLoadList()
        },
        getDetailData() {
            this.getDetailList()
        },
        // 获取信源中心数据
        getList (type){
            let that = this;
            that.type = type;
            that.selectMedia={
                name:'全部',
                value:'total'
            };
            that.$api.get('custom/info-source/list',{
                perpage:300,
                page:that.totalPage
            },r =>{
                that.$parent.showLoad = false;
                that.initialList = r.data.data;
                that.totalCount = Number(r.data.count);
                that.conditionScreen();
            })
        },
        // 获取媒体类型
        getMediaPlatform () {
            let that = this;
            that.platformType = [];
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('scheme/info-source/platforms', null, r => {
                that.$utils.returnCode(r,function(){
                    that.MediaPlatformList = r.data.all;
                    that.otherPlatformList = r.data.other;
                    that.getList('follow');
                });
            })
        },
        // 选择平台
        selectMediadata (item,type){
            if(type === 0){//页面展示类别
                this.selectMedia={
                    name:item.name,
                    value:item.value,
                    childName:'',
                    childValue:'',
                }
                this.conditionScreen();
            }else{//弹框类别
                if(item.name === '视频') return;
                this.selectMedias={
                    name:item.name,
                    value:item.value,
                    childName:'',
                    childValue:'',
                }
            }
        },
        //选择二级平台
        selectMediachild(item,child,type){
            if(type === 0){//页面展示类别
                this.selectMedia={
                    name:item.name,
                    value:item.value,
                    childName:child.name,
                    childValue:child.value,
                }
                this.conditionScreen();
            }else{//弹框类别
                this.selectMedias={
                    name:item.name,
                    value:item.value,
                    childName:child.name,
                    childValue:child.value,
                }
            }
        },
        KeyUpEsc (){
            this.conditionScreen();
        },
        // 条件筛选
        conditionScreen (){
            let list = this.initialList;
            let key = this.selectMedia.value;
            let keyword = this.keyword;
			let result;
			result = list.filter(item => {
                return (item.source.indexOf(keyword) != -1||item.originPlatformName.indexOf(keyword) != -1||item.domain.indexOf(keyword) != -1||item.mediaId.indexOf(keyword) != -1)
            })
            this.list = result;
            if(this.list == ''){
                this.nodata = true;
            }else{
                this.nodata = false;
            }
        },
        // 打开信源设置
        openSource (){
            this.selectMedias={
                name:'网页',
                value:'web',
                childName:'',
                childValue:'',
            }
			this.keywords = '';
			this.lists = [];
            this.nodatas = false;
            this.addShow = true
        },
        // 弹框搜索信源
        searchSource (){
            let that = this;
            that.platformType = [];
            if(that.keywords == ''){
                that.$utils.alertText('请输入搜索内容');
                return;
            }
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('custom/info-source/search', {platform:that.selectMedias.value,platformSec:that.selectMedias.childValue,source:that.keywords}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.lists = '';
                    if(r.data == ''){
                        that.nodatas = true;
                    }else{
                        that.nodatas = false;
                        that.lists = r.data;
                        that.initialLists = r.data;
                    }
                });
            })
        },
        // 添加信源
        addSource (index){
            let that = this;
            let list = that.lists[index];
            let data1 = {
                sid:that.planId,
                type:that.type,
            }
            let data = Object.assign(data1,list);
			that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('custom/info-source/add', {data:data}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.lists[index].isExist = 1;
                    that.initialList.push(r.data);
                    that.conditionScreen();
                });
            })
        },
        delSource (id,type){
            let that = this;
            let ids = [];
            let text = '是否确认删除此条信源？';
            if(id){
                ids.push(id)
            }else{
                let list = that.list;
                ids = list.map(v=>v.id);
                text = '是否删除所有信源？'
            }
            that.$confirm(text).then(() => {
                that.$api.get('custom/info-source/del', {ids:ids}, r => {
                    that.$utils.returnCode(r,function(){
                        that.$parent.showLoad = false;
                        for(let i of ids){
                            that.initialList.splice(that.initialList.findIndex(item => item.id === i), 1);
                        }
                        that.conditionScreen();
                        if(that.list.length <= 0){
                            that.nodata = true;
                        }
                        that.$utils.alertText('删除成功');
                        that.$store.dispatch('show/changeToast',{text:'删除成功'})
                        if(type === 1) {
                            that.getDetailList()
                        }else {
                            that.getList ();
                        }
                    });
                })
            })
        }
    }
}
</script>
<style scoped>
/deep/.download-table {
    height: 360px;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/sourceSet.vue